import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { Elements } from 'react-stripe-elements';
import { accountRoute } from '../../routes';

import connect from '../../utils/connect';

import Splitter from '../account/block/splitter';
import ContentBlock from '../account/block/content';
import ConfirmDialog from  '../form/confirm';
import Spinner from '../svg/spinner';

import Step1 from '../account/caseCreate/step1';
import Step2 from '../account/caseCreate/step2';
import Step3 from '../account/caseCreate/step3';
import Step4 from '../account/caseCreate/step4';

//import translate from '../../utils/translate';

import { redirectToPathIf } from '../../utils/authorization';
import { AccountLoginForm } from '../../containers/account/login';

const CASE_STEP0 = 0;
const CASE_STEP1 = 1;
const CASE_STEP2 = 2;
const CASE_STEP3 = 3;
const CASE_STEP4 = 4;

class CaseSubmitNotLoggedIn extends Component {

	constructor(props) {
		super();

		this.state = {
			waiting: false,
			step: CASE_STEP0,
		};
	}

	componentDidMount() {
		redirectToPathIf(this.props.dispatch, accountRoute('/profile/projects/create'), this.props.users.isLoggedIn(), false);
	}

	componentWillReceiveProps(nextProps) {
		redirectToPathIf(this.props.dispatch, accountRoute('/profile/projects/create'), this.props.users.isLoggedIn(), { step: '1' });
	}

	render() {
		return (
			<div className='account-process account-process--standalone'>
				<Helmet title='The FWA - Account - Submit Project' />


				{(this.state.step === CASE_STEP0) && this.renderStep0()}

				{(this.state.step === CASE_STEP1) && this.renderStep1()}

				<Step1 activeStep={0} goToStep={() => {}} goForward={() => {}} dispatch={this.props.dispatch} user={this.props.users} />
				<Step2 activeStep={0} goToStep={() => {}} goForward={() => {}} dispatch={this.props.dispatch} />
				<Elements><Step3 activeStep={0} goToStep={() => {}} goForward={() => {}} dispatch={this.props.dispatch} /></Elements>
				<Step4 activeStep={0} goToStep={() => {}} goForward={() => {}} dispatch={this.props.dispatch} slug='' />

			</div>
		);
	}

	renderStep0() {
		return (
			<div>
				<ContentBlock title=''>
					<div className='account-process__title-area'>
						<strong>We award the best there is</strong><br />

						FWA is where you go to experience cutting-edge innovation in digital design and development. It’s a space that encourages the digital industry to push the boundaries of technology, to show people what is possible.
					</div>
				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01'>
					<div className='account-process__button-area'>
						<button className='button--dark' onClick={this.start.bind(this)}>Submit to FWA</button>
						<span className='account-process__button-area__button-desc'><span className='hide-mobile'>Submit to FWA:</span> £70.50 GBP</span>
					</div>
				</ContentBlock>
			</div>
		);
	}

	renderStep1() {
		return (
			<div>
				<ContentBlock title=''>
					<div className='account-process__title-area'>
						<strong>Log in to submit project</strong><br />

						Don’t worry, your login just enables you to edit and update your project at a later point.
					</div>
				</ContentBlock>

				<AccountLoginForm {...this.props} />
			</div>
		);
	}

	start() {
		if (this.state.step === CASE_STEP0) {
			this.setState({
				...this.state,
				step: CASE_STEP1,
			});
		} else { //@TODO remove this when form is hooked up
			this.cycleSteps();
		}
	}
}

export default connect(CaseSubmitNotLoggedIn);



/** WEBPACK FOOTER **
 ** ./frontend/components/submit/caseSubmit.js
 **/